import React, { useRef } from "react";
import Perform2023IntroSection from './perform2023/perform2023IntroSection';
import Perform2023GridSection from './perform2023/perform2023GridSection';
import Perform2023VideoSection from './perform2023/perform2023VideoSection';
import Perform2023EmbedSection from './perform2023/perform2023EmbedSection';
import Perform2023RegistrationSection from './perform2023/perform2023RegistrationSection';
import Perform2023SpeakersSection from './perform2023/perform2023SpeakersSection';
import Perform2023GallerySection from './perform2023/perform2023GallerySection';
import Perform2023LogosSection from './perform2023/perform2023LogosSection';
import Perform2023TicketsSection from './perform2023/perform2023TicketsSection';
import Perform2023AgendaSection from './perform2023/perform2023AgendaSection';
import { ParallaxProvider } from "react-scroll-parallax";
import '../../sass/components/flexibleModules/_components.Perform2023Block.scss';

const Perform2023Block = ({ data }) => {
    const containerRef = useRef(null)

    return ( 
        <ParallaxProvider>
            <div className={`cp-perform2023Section ${data.overrideClass}`} data-scroll-section>
                <div className="cp-perform2023Section__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }} data-scroll-container ref={containerRef}>
                    {data.perform2023FlexiFields.map((performFlexiTypes, index) => (
                        <React.Fragment key={index}>
                            {performFlexiTypes.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23IntroSection' &&
                                <Perform2023IntroSection data={performFlexiTypes} />
                            }
                            {performFlexiTypes.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23GridSection' &&
                                <Perform2023GridSection data={performFlexiTypes} />
                            }
                            {performFlexiTypes.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23VideoSection' &&
                                <Perform2023VideoSection data={performFlexiTypes} />
                            }
                            {performFlexiTypes.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23EmbedSection' &&
                                <Perform2023EmbedSection data={performFlexiTypes} />
                            }
                            {performFlexiTypes.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23RegistrationSection' &&
                                <Perform2023RegistrationSection data={performFlexiTypes} />
                            }
                            {performFlexiTypes.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23SpeakersSection' &&
                                <Perform2023SpeakersSection data={performFlexiTypes} />
                            }
                            {performFlexiTypes.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23GallerySection' &&
                                <Perform2023GallerySection data={performFlexiTypes} />
                            }
                            {performFlexiTypes.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23LogosSection' &&
                                <Perform2023LogosSection data={performFlexiTypes} />
                            }
                            {performFlexiTypes.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23TicketSection' &&
                                <Perform2023TicketsSection data={performFlexiTypes} />
                            }
                            {performFlexiTypes.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23AgendaSection' &&
                                <Perform2023AgendaSection data={performFlexiTypes} />
                            }
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </ParallaxProvider>
    );
}

export default Perform2023Block;